import React, { Component } from 'react';
import Select from 'react-select';
import { Row, Col, Table } from "react-bootstrap";
import { CustomCard } from "../../components/Card/CustomCard";

import { ConsultaMisSecciones, EstPorSeccion, RendimientoXls } from '../../funciones/CalifFunction';
import ListaEstudiantes from '../Estudiantes/ListaEstudiantes';

import ModalReports from '../../components/Reportes/ModalReports';
import ListadoEstudiantes from '../../components/Reportes/ListadoEstudiantes';


class MisAulas extends Component {
    state = {
        valorSeccion: { value: '', label: '- Secciones -' },
        secciones: [{
            value: '',
            label: ' - Cargando - ', codigo: '',
            carrera: '',
            semestre: '',
            seccion: ''
        }],
        estudiantes: [],
        preloader: {
            icon: "",
            text: ""
        },
        textInicial: "Selecciona una sección",
        gender:"",
        button: {
            icon:"fa fa-print",
            text: "Imprimir Listado"
        },
        button2: {
            icon: "fa fa-file-excel-o",
            text: "Descargar en xls"
        },
        openW:false,
    }

    constructor (props) {
        super (props);

        ConsultaMisSecciones ((resp) => {
            this.setState({
                secciones: resp[0]
            })
        })
    }

    valorSeccion = (valorSeccion) => {
        this.setState({
            valorSeccion,
            preloader: {
                icon: "fa fa-circle-o-notch fa-spin",
                text: "Buscando estudiantes"
            },
            textInicial: "",
        }, () => {
            EstPorSeccion(valorSeccion.value, (resp) => {
                if (resp[0].length === 0){
                    this.setState({
                        estudiantes: resp[0],
                        preloader: {
                            icon: "",
                            text: ""
                        },
                        textInicial: "La sección seleccionada no tiene estudiantes inscritos",
                    })
                }else{
                    this.setState({
                        estudiantes: resp[0],
                        gender: resp[1],
                        preloader: {
                            icon: "",
                            text: ""
                        },
                        textInicial: "",
                    })
                }
            })
        })
    }

    modal = () => {
        let { valorSeccion, estudiantes } = this.state;
        if (this.state.openW === false) return null;
        return (
            <ModalReports
                reporte={<ListadoEstudiantes
                    seccion={valorSeccion}
                    estudiantes={estudiantes}
                />}
                titulo="Impresión de Listado de Estudiates"
                display= "block"
                cerrar = {() => {this.setState({openW:false})}}
                />
        )
    }

    estudiants = () => {
        let { estudiantes } = this.state;
        if(estudiantes.length === 0) return (
            <tr>
                <td colSpan={5} align= "center" style={{padding: 5, fontSize: 12}}>
                    No existen estudiantes en esta sección
                </td>
            </tr>
        )

        let num = 1
        let numero = () => { return num ++; }

        let num2 = 1
        let numero2 = () => { return num2 ++; }

        return (
            estudiantes.map(option => (
                <ListaEstudiantes 
                    key={ `est_${numero2()}` }
                    num = {numero()}
                    est = { option }
                />
            ))
        )
    }

    imprimir = () => (e) => {
        this.setState({
            /* button: {
                icon:"fa fa-spinner fa-spin",
                text: "Generando Espere"
            }, */
            openW:true,
        })
    }

    downloadReporte = () => (e) => {
        let { valorSeccion } = this.state;
        this.setState({
            button2: {
                icon:"fa fa-spinner fa-spin",
                text: "Generando Espere"
            }
        }, () =>{
            RendimientoXls(valorSeccion.value, valorSeccion.seccion, (resp) => {
                this.setState({
                    button2: {
                        icon: "fa fa-file-excel-o",
                        text: "Descargar en xls"
                    }
                })             
            })
        })
    }

    estadistica = () => {
        let { estudiantes, textInicial, valorSeccion, gender, button, button2 } = this.state;

        let M = gender.masculino;
        let F = gender.femenino;
        let total = estudiantes.length;

        let porcentajeM = (M * 100) / total;
        let porcentajeF = (F * 100) / total;

        if (estudiantes.length === 0) return (
            <div align="center" className="text-muted custom-mt-10">{textInicial}</div>
        )

        const styles = {
            padding: 5, fontSize: 12
        }
        
        return(
            <React.Fragment>
                <div className="custom-alert-warning custom-mt-10" style={{fontSize:10}}>Datos estadísticos de la sección <strong>{valorSeccion.seccion}</strong></div>
                <Row className="custom-mt-10">
                    <Col md={2}>
                        <div style={{fontSize:10}} className="text-danger">Inscritos:</div>
                        <div style={{fontSize:10}} className="text-muted">({estudiantes.length}) estudiantes</div>
                    </Col>
                    <Col md={5}>
                        <div style={{fontSize:10}} className="text-danger">Femenino <span className="text-muted">({F}) estudiantes</span></div>

                        <div className="progress">
                            <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeF)}%`, backgroundColor:"#A0555C"}}>
                                {Math.round(porcentajeF)}%
                            </div>
                        </div>
                    </Col>
                    <Col md={5}>
                        <div style={{fontSize:10}} className="text-danger">Masculino <span className="text-muted">({M}) estudiantes</span></div>

                        <div className="progress">
                            <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeM)}%`, backgroundColor:"#1f2f6e"}}>
                                {Math.round(porcentajeM)}%
                            </div>
                        </div>
                    </Col>
                    <Col md={12} className="custom-mt-10">
                        <div className="table-responsive">
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td width={30} style={styles}><strong>N°</strong></td>
                                        <td width="20%" style={styles}><strong>Cédula</strong></td>
                                        <td width="80%" colSpan={2} style={styles}><strong>Estudiantes</strong></td>
                                    </tr>
                                    {this.estudiants()}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                    <Col md={12} align="right" className="custom-mt-10">
                        <div className="btn-group">
                            <button className="btn btn-success" onClick = {this.downloadReporte()} style={{borderWidth: 1}}><i className={button2.icon}></i> {button2.text}</button>
                            <button className="btn btn-primary" onClick={this.imprimir()} style={{borderWidth: 1}}><i className={button.icon}></i> {button.text}</button>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    contenido = () => {
        let { secciones, valorSeccion, preloader } = this.state;

        const customStyles = (base) => ({
            ...base,
            fontSize: 10,
        });

        return (
            <React.Fragment>
                <div className="custom-alert-info" style={{padding:5}}>
                    <Row>
                        <Col md={5}>
                            <div className="custom-mt-10">Selecciona una sección</div>
                        </Col>
                        <Col md={7}>
                            <Select
                                styles={{menu: customStyles}}
                                isSearchable ={true}
                                value={valorSeccion}
                                onChange={this.valorSeccion}
                                options={secciones}
                            />
                        </Col>
                    </Row>
                </div>
                <div align="center" className="text-muted custom-mt-10"><i className={preloader.icon}></i> {preloader.text}</div>
                {this.estadistica()}
            </React.Fragment>
        )
    }

    ayuda = () => {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12} align="justify">
                        <div>
                            Luego de seleccionar <strong style={{color:"#1f2f6e"}}>la sección</strong> podrás ver lo siguiente:
                        </div>
                    </Col>
                    <Col md={12} align="justify" className="custom-mt-10">
                        <div className="custom-alert-warning">Datos estadísticos...</div>
                    </Col>
                    <Col md={12} align="justify" className="custom-mt-10">
                        <div>En esta área encontrarás detalles de la sección respecto a la cantidad de estudiantes inscritos, separados por masculinos y femeninos con una barra indicadora del porcentaje total para cada género.</div>
                    </Col>

                    <Col md={5} align="justify" className="custom-mt-10">
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                aria-valuemin="0" aria-valuemax="100" style={{width: "35%", backgroundColor:"#A0555C"}}>
                                35%
                            </div>
                        </div>
                    </Col>
                    <Col md={7} align="justify" className="custom-mt-10">
                        Corresponde a los estudiantes femeneninos inscritos.
                    </Col>

                    <Col md={5} align="justify" className="custom-mt-10">
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                aria-valuemin="0" aria-valuemax="100" style={{width: "65%", backgroundColor:"#1f2f6e"}}>
                                65%
                            </div>
                        </div>
                    </Col>
                    <Col md={7} align="justify" className="custom-mt-10">
                        Corresponde a los estudiantes masculinos inscritos.
                    </Col>

                    <Col md={12} align="justify" className="custom-mt-10">
                        <div>También tienes a disposición el listado de estudiantes inscritos para la sección seleccionada con sus nombres y apellidos.</div>
                    </Col>

                    <Col md={12} align="justify" className="custom-mt-10">
                        <div><strong style={{color:"#1f2f6e"}}>Impresión y descarga</strong></div>
                    </Col>

                    <Col md={4} align="justify" className="custom-mt-10">
                        <button className="btn btn-success btn-xs" style={{borderWidth: 1, fontSize:10}}><i className="fa fa-file-excel-o"></i> Descargar en xls</button>
                    </Col>
                    <Col md={8} align="justify" className="custom-mt-10">
                        Este botón permite descargar en formato <strong>xls</strong> el registro de calificaciones de la sección.
                        <div style = {{fontSize: 10}} className="custom-mt-10"><strong>Importante: Al descargar el archivo .xls, asegúrate de NO CAMBIAR el nombre de la hoja (La pestaña que aparece en la parte inferior al abrir el archivo) ya que este es utilizado por el sistema.</strong></div>
                    </Col>

                    <Col md={4} align="justify" className="custom-mt-10">
                        <button className="btn btn-primary btn-xs" style={{borderWidth: 1, fontSize:10}}><i className="fa fa-print"></i> Imprimir Listado</button>
                    </Col>
                    <Col md={8} align="justify" className="custom-mt-10">
                        Este botón permite ver o imprimir un listado de los estudiantes de la sección.
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
    
    render() { 
        return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col md={8}>
                            <div style={{borderRadius: "4px 4px"}}>
                                <CustomCard
                                    title="Mis aulas"
                                    category=""
                                    color="#a80012"
                                    content={this.contenido()}
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div style={{borderRadius: "4px 4px",}}>
                                <CustomCard
                                    styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                    title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                    category={<span style={{color: "#fff"}}>Mis Aulas</span>}
                                    color="#a80012"
                                    content={this.ayuda()}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                {this.modal()}
            </React.Fragment>
        );
    }
}
 
export default MisAulas;


// WEBPACK FOOTER //
// ./src/views/ProfAulas/MisAulas.jsx